import React from "react";
import logo from "../../assets/bizdeploy-logo.svg";
import "../header/Header.css";

const Header = () => {
  return (
    <header className="App-header">
      <div className="header-content">
        <div className="header-copy">
          <img src={logo} alt="BizDeploy Logo" className="logo" />
          <p className="header-kicker">Ethical technology implementation</p>
          <h1>Build a better digital operation.</h1>
          <p className="tagline">
            BizDeploy helps Muslim organisations and ethical businesses use AI,
            automation, and connected digital systems to do more with less
            friction.
          </p>
          <div className="header-actions">
            <a href="#services-overview" className="cta-button primary">
              Explore how we help
            </a>
            <a href="#contact" className="cta-button secondary">
              Book a consultation
            </a>
          </div>
          <a
            href="https://ramadan.mya.org.au/t/bizdeploy"
            target="_blank"
            rel="noopener noreferrer"
            className="partnership-link"
          >
            Contribute to our Ramadan Fundraiser 2026!
          </a>
        </div>

        <div
          id="services"
          className="service-explorer"
          aria-label="Ways BizDeploy can help"
        >
          <div className="service-explorer-header">
            <span className="service-status-dot" aria-hidden="true"></span>
            <span>Digital operations, connected</span>
          </div>
          <div className="service-list">
            <a href="#technologies" className="service-item">
              <span className="service-index">01</span>
              <span>
                <strong>AI and automation</strong>
                <small>Reduce repetitive work and support your team.</small>
              </span>
              <span className="service-arrow" aria-hidden="true">
                ↗
              </span>
            </a>
            <a href="#contact" className="service-item">
              <span className="service-index">02</span>
              <span>
                <strong>Digital systems</strong>
                <small>
                  Connect websites, software, and productivity tools.
                </small>
              </span>
              <span className="service-arrow" aria-hidden="true">
                ↗
              </span>
            </a>
            <a href="#wix-migration" className="service-item">
              <span className="service-index">03</span>
              <span>
                <strong>Ethical technology</strong>
                <small>Make technology choices that reflect your values.</small>
              </span>
              <span className="service-arrow" aria-hidden="true">
                ↗
              </span>
            </a>
          </div>
          <p className="service-explorer-note">
            Practical support for organisations without an in-house technology
            team.
          </p>
        </div>
      </div>
    </header>
  );
};

export default Header;
